/**
 * disclaimer.js — оговорка «не для диагностики»: один текст на всю программу.
 *
 * ПОЧЕМУ ЭТО ВООБЩЕ ЕСТЬ. Программа не просто показывает снимки — она выдаёт
 * ЧИСЛА, по которым врач действует: кальций по Агатстону с классом бляшки и
 * перцентилем MESA, объём очага в миллилитрах, динамику между датами, D95 и
 * V100, диаметр аорты, плотность костной ткани, фракцию выброса. Ни одно из
 * этих чисел не проверено на фантомах против эталонного прибора, не проходило
 * клинических испытаний и не сравнивалось с референсным ПО. Сама программа не
 * зарегистрирована как медицинское изделие ни в одной юрисдикции.
 *
 * ЧЕГО ЭТА НАДПИСЬ НЕ ДАЁТ, и это надо понимать точно. Она НЕ освобождает от
 * регистрации. Назначение изделия определяется тем, что программа делает, а не
 * наклейкой: как только появляются измерения и расчёты, «только показываем»
 * заканчивается. Смысл надписи другой — предупредить человека у экрана.
 *
 * ПОЧЕМУ НЕ ТОЛЬКО В ФУТЕРЕ. Числа уезжают из программы: в PDF, в отчёт, в
 * снимок. Врач через месяц смотрит на PDF, футера там нет — и объём очага
 * выглядит как показание прибора. Поэтому короткая строка обязана печататься
 * в каждом экспорте, где есть числа. Здесь она одна на всех, чтобы формулировка
 * не разъехалась по файлам.
 *
 * Файл без импортов: текст проверяется тестом, а не разглядыванием экрана.
 */

/** Короткая — в футер, в колонтитул PDF, в подпись снимка. */
export const КОРОТКО = 'Не для диагностики';

/** Одной строкой — для экспорта, где места мало (PDF, CSV, снимок). */
export const СТРОКА = 'Не для диагностики. Измерения и расчёты не проверены на фантомах '
  + 'и не проходили клинических испытаний; программа не зарегистрирована как медицинское изделие.';

/** Полностью — окно по нажатию на надпись в футере. */
export const ПОЛНЫЙ = [
  'Не для диагностики.',
  '',
  'Эта программа не зарегистрирована как медицинское изделие и не проходила '
  + 'клинических испытаний. Измерения и расчёты — объём очага, кальциевый счёт, '
  + 'DVH и дозовые показатели, диаметры, плотность костной ткани, фракция '
  + 'выброса — не проверены на фантомах против эталонного прибора и не '
  + 'сравнивались с референсным программным обеспечением.',
  '',
  'Числа из неё нельзя использовать как показания сертифицированного прибора '
  + 'и нельзя приводить в медицинском заключении в качестве измеренных величин. '
  + 'Решение принимает врач по данным допущенного оборудования.',
  '',
  'Это относится и к файлам, которые программа сохраняет: PDF, отчёты, снимки, '
  + 'таблицы и DICOM SR несут ту же оговорку — она печатается в них намеренно.',
].join('\n');

/**
 * Строка для колонтитула экспорта: оговорка, версия и дата — в одну линию.
 * @param {string} [версия]
 * @param {Date} [когда]
 */
export function дляЭкспорта(версия = '', когда = new Date()) {
  const д = `${String(когда.getDate()).padStart(2, '0')}.${String(когда.getMonth() + 1).padStart(2, '0')}.${когда.getFullYear()}`;
  return СТРОКА + (версия ? ` · Mikhmel Cornerstone4D ${версия}` : '') + ` · ${д}`;
}

export default { КОРОТКО, СТРОКА, ПОЛНЫЙ, дляЭкспорта };
